import React from 'react';
import { Helmet } from 'react-helmet-async';
import TeachHeroSection from '@/components/TeachPage/TeachHeroSection';
import TeachBenefitsSection from '@/components/TeachPage/TeachBenefitsSection';
import TeachStepsSection from '@/components/TeachPage/TeachStepsSection';
import TeachCTASection from '@/components/TeachPage/TeachCTASection';
import TeachFAQSection from '@/components/TeachPage/TeachFAQSection';
import { useI18n } from '@/i18n';

const TeachPage: React.FC = () => {
  const { locale } = useI18n();
  return (
    <>
      <Helmet>
        <title>{locale === 'zh-CN' ? '成为导师 | Tutor Founder' : 'Become a Tutor | Tutor Founder'}</title>
        <meta
          name="description"
          content={
            locale === 'zh-CN'
              ? '加入马来西亚导师社群，自订收费、安排自己的授课时间，把知识转化为收入。今天就免费注册。'
              : "Join Malaysia's tutor community. Set your own rate, teach on your schedule, and turn your knowledge into income. Sign up free today."
          }
        />
      </Helmet>

      <TeachHeroSection />
      <TeachBenefitsSection />
      <TeachStepsSection />
      <TeachFAQSection />
      <TeachCTASection />
    </>
  );
};

export default TeachPage;
